"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Icon_1 = require("../Icons/Icon/Icon");
var Theme_1 = require("../Theme");
var Message = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    height: 16px;\n    color: #e83a3a;\n    font-size: ", ";\n    margin-top: ", ";\n    & > span:first-of-type {\n        margin: 1px 4px 0 0;\n    }\n"], ["\n    display: flex;\n    height: 16px;\n    color: #e83a3a;\n    font-size: ", ";\n    margin-top: ", ";\n    & > span:first-of-type {\n        margin: 1px 4px 0 0;\n    }\n"])), Theme_1.FontSize, Theme_1.PixelUnit(1));
Message.displayName = "Message";
var ErrorMessage = /** @class */ (function (_super) {
    __extends(ErrorMessage, _super);
    function ErrorMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorMessage.prototype.render = function () {
        return (React.createElement(Message, { "aria-live": "assertive" },
            React.createElement(Icon_1.Icon, { Icon: this.props.Icon, Height: "15px", Width: "15px" }),
            React.createElement("span", null, this.props.Message)));
    };
    return ErrorMessage;
}(React.Component));
exports.ErrorMessage = ErrorMessage;
var templateObject_1;
